<template>
  <div class="bread-crumb rounded">
    <div class="nome-tela">{{ nomeTela }}</div>    
  </div>
</template>

<script>
export default {
  name: 'BreadCrumb',
  data() {
    return {
    };
  },
  computed: {
    nomeTela() {
      const { route } = this.$router.resolve({path: this.$route.path});
      return route.meta.nomeTela || '';
    }
  },
}
</script>

<style lang="scss">
.bread-crumb {
  // padding: 15px;
  .v-breadcrumbs {
    padding: 3px 15px;
  }

  .crumb {
    text-decoration: none;
    color: rgb(155, 171, 197);
    
    &:hover {
      color: #039be5;
    }
  }

  .disabled {
  color: rgb(16, 47, 104);
  pointer-events: none;
  }

  .nome-tela {
    font-size: 24px;
    margin-left: 15px;
  }
}
</style>
